angular.module('qkr.department')
    .controller('DepartmentManagmentModalDialogController', departmentModalManagement);

    departmentModalManagement.$inject = ['$scope', '$rootScope', '$uibModal', '$uibModalInstance', 'merchantService',
        'departmentService', 'paymentgatewayService', 'FormHelper', 'utils', 'isEdit',
        'department', 'paymentConfigList', 'gettextCatalog', 'appConfig'];

    function departmentModalManagement($scope, $rootScope, $uibModal, $uibModalInstance, merchantService, departmentService,
                                       paymentgatewayService, FormHelper, utils, isEdit, department, paymentConfigList,
                                       gettextCatalog, appConfig) {
        const formHelper = new FormHelper($scope);

        // TODO remove hack
        const vm = $scope;
        
        vm.isEdit = isEdit;
        vm.department = department;
        vm.paymentConfigList = paymentConfigList;
        vm.saving = false;
        vm.form = {};
        vm.isDepartmentNameDisabled = false;

        const init = function() {
            vm.isUpdatePaymentConfigAllowed = showAddPaymentConfigButton();
            vm.isExternalDeptCodeRequired = showExternalDeptCodeAsRequired();
            vm.showLedgerReference = showLedgerReference();
            // Pre-select options and inputs
            // vm.selectPaymentConfigOption($rootScope.merchantInfo.paymentConfig);
            vm.selectPaymentConfigOption(vm.addDefaultPaymentConfig());

            if (vm.isEdit) {
                if (!utils.hasNoValue(vm.department.name)) {
                    vm.form.departmentname = vm.department.name;
                    vm.isDepartmentNameDisabled = departmentService.checkIfDepartmentNameDisabled(vm.department.name);
                }
                if (!utils.hasNoValue(vm.department.coverImage)) {
                    vm.form.image = vm.department.coverImage;
                }
                if (!utils.hasNoValue(vm.department.description)) {
                    vm.form.description = vm.department.description;
                }

                vm.hasNoThankYouMessage = utils.hasNoValue(vm.department.purchaseThankYouMessage);
                if (!vm.hasThankYouMessage) {
                    vm.form.purchaseThankYouMessage = vm.department.purchaseThankYouMessage;
                }
                if (!utils.hasNoValue(vm.department.paymentConfig)) {
                    vm.selectPaymentConfigOption(vm.department.paymentConfig);
                } else {
                    vm.selectPaymentConfigOption(vm.addDefaultPaymentConfig());
                }
                if (!utils.hasNoValue(vm.department.externalDepartmentCode)) {
                    vm.form.departmentCode = vm.department.externalDepartmentCode;
                }
                if (vm.department.ledgerReference !== undefined) {
                    vm.form.ledgerReference = vm.department.ledgerReference;
                }
            }
        };

        vm.changeStoreFrontThankYouDefaultCheckBox = function() {
            if (!vm.hasThankYouMessage) {
                vm.form.purchaseThankYouMessage = null;
            }
        };

        vm.selectPaymentConfigOption = function(paymentConfig) {
            if (!paymentConfig)
                return;

            const id = paymentConfig.id;
            angular.forEach(vm.paymentConfigList, (paymentConfig) => {
                if (paymentConfig.id === id) {
                    vm.form.paymentconfig = paymentConfig;
                }
            });
        };

        vm.saveDepartment = function() {
            // Get form options as instances from list
            vm.form.selectedPaymentConfig = vm.form.paymentconfig;
            if (vm.form.selectedPaymentConfig && vm.form.selectedPaymentConfig.id === 0) {
                vm.form.selectedPaymentConfig = null;
            }

            if (!vm.validateForm()) {
                return;
            }

            if (!vm.isEdit) {
                vm.department = {};
            }

            vm.department.name = vm.form.departmentname;
            // vm.department.coverImage = vm.form.image;
            vm.department.description = vm.form.description;
            vm.department.externalDepartmentCode = vm.form.departmentCode;
            vm.department.ledgerReference = vm.form.ledgerReference;
            vm.department.purchaseThankYouMessage = vm.form.purchaseThankYouMessage;

            if (vm.isEdit) {
                vm.department.paymentConfig = vm.form.selectedPaymentConfig;
            } else {
                vm.department.paymentConfigId = vm.form.selectedPaymentConfig ? vm.form.selectedPaymentConfig.id :
                    vm.form.paymentConfig;
            }

            vm.department.supportedTimeZone = {id: $rootScope.outletInfo.timezoneId};

            vm.saving = true;

            if (!vm.isEdit) {
                departmentService.createDepartmentPost(vm.department).then((promise) => {
                    vm.saveDepartmentCallback(promise);
                }, (promise) => {
                    vm.saveDepartmentCallback(promise);
                });
            } else {
                departmentService.updateDepartmentPost(vm.department).then((promise) => {
                    vm.saveDepartmentCallback(promise);
                }, (promise) => {
                    vm.saveDepartmentCallback(promise);
                });
            }
        };

        $scope.cancel = function() {
            $uibModalInstance.close('cancel');
        };

        // Perform some simple client side validation
        vm.validateForm = function() {
            // Empty the errors list
            vm.errors = null;
            let valid = true;
            const errors = {};
            if (utils.hasNoValue(vm.form.departmentname)) {
                errors.departmentname = gettextCatalog.getString('Please enter a name.');
                valid = false;
            }
            if (vm.isExternalDeptCodeRequired && utils.hasNoValue(vm.form.departmentCode)) {
                errors.departmentCode = gettextCatalog.getString('Please enter a external department code.');
                valid = false;
            }
            if (vm.showLedgerReference && utils.hasNoValue(vm.form.ledgerReference)) {
                errors.ledgerReference = gettextCatalog.getString('Please enter a ledger reference.');
                valid = false;
            }

            vm.errors = errors;

            return valid;
        };

        // Handle response from attempted save
        vm.saveDepartmentCallback = function(response) {
            const r = formHelper.handleResponse(response);

            if (r.isSuccess()) {
                $uibModalInstance.close('done');
            } else {
                vm.saving = false;
                if (response.data.errors[0].field === 'name') {
                    vm.errors = null;
                    const errors = {};
                    errors.departmentname = gettextCatalog.getString('Name already exists');
                    vm.errors = errors;
    //            	MessageService.error("Department name already exists");
                }
            }
        };

        function showExternalDeptCodeAsRequired() {
            return merchantService.behaviour(merchantService.merchantInfo, 'deptEditPage.isExternalDeptCodeRequired');
        }

        function showLedgerReference() {
            return merchantService.behaviour(merchantService.merchantInfo, 'deptEditPage.showLedgerReference');
        }

        function showAddPaymentConfigButton() {
            if (merchantService.behaviour(merchantService.merchantInfo, 'deptEditPage.showAddPaymentConfigButton')) {
                return appConfig.isMCAdmin || appConfig.isPartner;
            } else {
                return false;
            }
        }

        // Add New Payment Setting button pressed
        vm.addPaymentConfig = function() {
            $uibModal.open({
                template: require('../../payment-gateway/templates/paymentgateway.html'),
                controller: 'paymentGatewayModalController',
                windowClass: 'fade modal-huge',
                backdrop: 'static',
                resolve: {
                    newPaymentSetting() {
                        return true;
                    },
                    paymentSetting() {
                        return {};
                    },
                    existingDefault() {
                        return paymentgatewayService.hasExistingDefault($rootScope);
                    },
                    paymentSystems() {
                        return paymentgatewayService.getPaymentSystems();
                    },
                    bankAccountTypes() {
                        return paymentgatewayService.getBankAccountTypes()
                    }
                }
            });
        };

        // Broadcasted by paymentGatewayModalController on New Payment Setting created
        vm.$on('paymentSettingsChanged', (evt, response) => {
            vm.paymentConfigList = response.data;
            vm.addDefaultPaymentConfig();

            if (vm.paymentConfigList.length > 0) {
                vm.form.paymentconfig = vm.paymentConfigList[vm.paymentConfigList.length - 1];
            }
        });

        vm.addDefaultPaymentConfig = function() {
            const defaultPaymentConfig = {
                id: 0,
                alias: gettextCatalog.getString('Use Merchant Default')
            };

            if (vm.paymentConfigList.length < 0 || !vm.paymentConfigList[0] || vm.paymentConfigList[0].id !== 0) {
                vm.paymentConfigList.unshift(defaultPaymentConfig);
            }

            return defaultPaymentConfig;
        };

    init();
}



// WEBPACK FOOTER //
// ./src/department/controllers/departmentmanagement.edit.controller.js